export default __webpack_public_path__ + "static/performanceSection4_img1-8b7f25a88f73bda77b71f158fdcf759a.png";